import Image from "next/image";
import styles from "./styles.module.scss";
import ImagePopup from "../../public/static-next/imagem_banner.png";
import LogoUrl from "../../public/static-next/logo-url.svg";
import Star from "../../public/static-next/star.svg";
import GoogleLogo from "../../public/static-next/google.svg";
import DotsSeparator from "../../public/static-next/dots.svg";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { PopupTypes } from "../../types/Popup";
import Link from "next/link";

interface ComponentTypes {
  popupData: PopupTypes;
  setShowPopup: Dispatch<SetStateAction<boolean>>;
}

export const Popup = ({ popupData, setShowPopup }: ComponentTypes) => {
  const [testimonialIndex, setTestimonialIndex] = useState<number>(0);

  useEffect(() => {
    setTestimonialIndex(
      Math.round(
        Math.random() * (popupData.popupTestimonialsRepeater.length - 1)
      )
    );
  }, []);

  const testimonial =
    popupData.popupTestimonialsRepeater[testimonialIndex].popupTestimonial;

  const googleScore = Math.round(popupData.fgrRating);
  const testimonialScore = Math.round(
    Number(testimonial.opcoesDoDepoimento.rating) ?? 5
  );

  return (
    <div className={styles.popup} id="popup">
      <div className={styles.popupContent}>
        <button
          className={styles.closeButton}
          aria-label="Fechar o Popup"
          onClick={() => {
            setShowPopup(false);
          }}
        >
          X
        </button>
        <div className={styles.productWrapper}>
          <div className={styles.imageWrapper}>
            <Image src={ImagePopup} fill alt="" />
          </div>
          <div className={styles.ctaWrapper}>
            <div
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: popupData.popupText }}
            ></div>
            <Link prefetch={false} href={popupData.popupButtonLink}>
              {popupData.popupButtonText}
            </Link>
          </div>
          <div className={styles.bottomInfo}>
            <LogoUrl />
          </div>
        </div>
        <div className={styles.contentWrapper}>
          <div
            className={styles.testimonial}
            dangerouslySetInnerHTML={{ __html: testimonial.content }}
          ></div>
          <div className={styles.reviewer}>
            <div className={styles.avatarWrapper}>
              <p>{testimonial.title.charAt(0)}</p>
            </div>
            <div>
              <p className={styles.author}>{testimonial.title}</p>
              <div className={styles.testimonialReview}>
                {[...Array(5)].map((e, i) => (
                  <Star key={i} data-active={testimonialScore > i} />
                ))}
              </div>
            </div>
          </div>
          <DotsSeparator className={styles.dotsSeparator} />
          <div className={styles.googleWrapper}>
            <GoogleLogo className={styles.googleLogo} />
            <div className={styles.googleScore}>
              <p>{popupData.fgrRating}</p>
              {[...Array(5)].map((e, i) => (
                <Star key={i} data-active={googleScore > i} />
              ))}
            </div>
            <p>{popupData.fgrUserRatingsTotal} reviews</p>
          </div>
        </div>
      </div>
    </div>
  );
};
